<template>
  <div>
    <el-dialog title="物流信息" :visible.sync="isShow" @close="close" style="height:700px;">
      <ul class="cght_ddxqbotulma">
        <li class="cght_ddxqbot1">
          <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
            <img :src="item.imgpath" width="60" height="60" :alt="item.title" />
          </router-link>
        </li>
        <li class="cght_ddxqbot2">
          <h3><router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">{{item.title}}</router-link></h3>
          <div>
            <el-tag size="mini" style="margin-left:3px" v-for="(ie,i) in item.specParamList" :key="i">{{ie.param_name}}：{{ie.option_value}}</el-tag>
          </div>
          <div>
            <div v-for="(ie,i) in item.leaveMessage" :key="i">
              <el-tag size="mini" effect="plain" style="margin-left:3px">{{ie.name}}：{{ie.value}}</el-tag>
            </div>
          </div>
        </li>
        <li class="cght_ddxqbot3" v-if="item.tax_price && item.tax_price > 0">￥{{item.tax_price}}</li>
        <li class="cght_ddxqbot3" v-else>询价</li>
        <li class="cght_ddxqbot4">数量：X{{item.number}}</li>
        <li class="cght_ddxqbot5" v-if="(item.tax_price * item.number) && (item.tax_price * item.number) > 0">￥{{(item.tax_price * item.number).toFixed(2)}}</li>
        <li class="cght_ddxqbot5" v-else>询价</li>
      </ul>
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color= '#fe722c'
          :timestamp="activity.time">
          {{activity.status}}
        </el-timeline-item>
      </el-timeline>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/order'

export default {
  name: 'Logistics',
  props: {
    dialogFormVisible: Boolean,
    parentsList: Object
  },
  data () {
    return {
      isShow: false,
      reverse: true,
      activities: [],
      item: ''
    }
  },
  mounted () {
    this.isShow = this.dialogFormVisible
    if (this.parentsList.express_number) {
      var data = {
        com: this.parentsList.expressagebh,
        nu: this.parentsList.express_number,
        tel: this.parentsList.tel
      }
      api.checkLogistics(data).then(res => {
        if (res.item.status === '0') {
          this.activities = res.item.result.list.reverse()
        } else {
          this.$message.error(res.item.msg)
        }
      })
      this.item = this.parentsList
      this.item.imgpath = this.parentsList.imgpath.split(',')[0]
    }
  },
  methods: {
    close () {
      this.$emit('changeParents', false)
    }
  }
}
</script>

<!-- 添加“scoped”属性来限制CSS只适用于此组件 -->
<style scoped>
.cght_ddxqbotulma{
  width: 815px;
  border: 1px solid #efefef;
  margin-bottom:15px;
}
.cght_ddxqbot1{
  width: 90px;
}
.cght_ddxqbot3{
  width: 90px;
  color:#fe722c;
}
.cght_ddxqbot4{
  width: 100px;
}
.cght_ddxqbot5{
  width: 80px;
  color:#fe722c;
}
</style>



// WEBPACK FOOTER //
// src/components/Logistics.vue